
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import React from 'react';
import { GetServerSideProps } from 'next';
import logger from 'utils/logger';

import { getBasicPageContentServerProps, parseBasicPageContent, parseSeoMetadata } from '../../common/basicContent';
import { SSR_PAGE_CACHE } from 'common/constants';
import modifyHeroProductBlock from 'api/queries/productHeroBlock';

const BASE_ROUTE = `news`;

type Props = {
  content: string; // JSON string value
};

const NewsPage: React.FC<Props> = ({ content }: Props) => {
  return (
    <>
      {parseSeoMetadata(content)}
      {parseBasicPageContent(content)}
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  const cookies = context.req.headers.cookie;

  if (context.query?.preview === undefined) {
    context.res.setHeader('Cache-Control', SSR_PAGE_CACHE);
  }

  let data = await getBasicPageContentServerProps(context, BASE_ROUTE);

  // request retailers list for ProductHeroSection
  try {
    data.props.content = await modifyHeroProductBlock(data.props.content, cookies);
  } catch (error) {
    logger.error(
      {
        err: error,
        journey: 'Page Content',
        source: 'CMS',
      },
      `error: Failed to modify product block on ${BASE_ROUTE} page`
    );
  }
  return data;
};

export default NewsPage;
